import { useContext } from "react";

import { useHistory, useParams } from "react-router-dom";

import RelatedReportsSection from "@/components/reports/RelatedReportsSection";
import { AvailableBadge, ComingSoonBadge, UnreleasedBadge } from "@/components/reports/Badges";
import { COMING_SOON } from "@/core/constants";
import { ViewerContext } from "@/tpo/Viewer";

import { REPORTS_LIST_QUERY, WARD_ENTITLEMENTS_QUERY } from "../reports/graphql/queries";

const DESCRIPTION =
  "This test has biomarkers that are featured within the below reports. These reports are available to purchase and give a holistic view of their body's function. Uniquely combining DNA & functional markers.";

function getReportCardState({ report }) {
  const isComingSoon = report?.purchaseProduct?.status === COMING_SOON;

  let topRightButton = null;
  if (isComingSoon) {
    topRightButton = <ComingSoonBadge />;
  } else if (!report.isAvailable) {
    topRightButton = <UnreleasedBadge />;
  } else {
    topRightButton = <AvailableBadge />;
  }

  return {
    isComingSoon,
    isClickable: !isComingSoon && report.isAvailable,
    topRightButton
  };
}

export default function WardRelatedReportsSection({ userTest }) {
  const history = useHistory();
  const { patientId } = useParams();
  const { userId } = useContext(ViewerContext);

  return (
    <RelatedReportsSection
      userTest={userTest}
      reportsQuery={REPORTS_LIST_QUERY}
      reportsQueryVariables={{
        userId,
        userTestId: userTest.id
      }}
      entitlementsQuery={WARD_ENTITLEMENTS_QUERY}
      entitlementsQueryVariables={{
        userId
      }}
      requireReportEntitlement
      skip={!userId}
      description={DESCRIPTION}
      getReportCardState={getReportCardState}
      onReportClick={report => {
        history.push(`/patients/${patientId}/reports/${report.slug}/overview`);
      }}
    />
  );
}
